// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3GMnd","image":"Header_image__2V_7t","name":"Header_name__1dxPL","info":"Header_info__u3C4L","infoRow":"Header_infoRow__iJi_z"};